export const CONTENTFUL_CONFIG = {
    SPACE_ID: '8ljdovk1ah0p',
    ACCESS_TOKEN: 'ETmuqDgAx9Bzr8V_Pvs4_b_VENJwTD3Z-dxY7JOZGh8',
    MANAGEMENT_TOKEN: 'CFPAT-qMN8FFEIpy3tDMSnbYGjaI5Nm2FLzcf2ZMvpxgTRIKw',
    CONTENT_TYPE_ID: 'user'
};
